<template>
  <div class="home">
    <!-- <HomeFeatured /> -->
    <ProjectSection />
    <!-- <NewsletterSection /> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HomeFeatured from "@/components/HomeFeatured.vue";
import ProjectSection from "@/components/ProjectSection.vue";
// import NewsletterSection from "@/components/NewsletterSection.vue";

export default {
  name: "HomeView",
  mounted() {
    document.title = "Sephen de Vos";
  },
  components: {
    // HomeFeatured,
    ProjectSection,
    // NewsletterSection,
  },
};
</script>
